export default __webpack_public_path__ + "static/media/chat-blank-icon.3e0fd208.svg";